import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-e8df5096"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "chat-main" }
const _hoisted_4 = { class: "input-area" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chat", { dark: $setup.darkMode }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["logo", { dark: $setup.darkMode }])
    }, _hoisted_2, 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["input", { dark: $setup.darkMode }])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["basic input-name", { dark: $setup.darkMode }]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputName) = $event)),
              placeholder: "名前"
            }, null, 2), [
              [_vModelText, $setup.inputName]
            ]),
            _withDirectives(_createElementVNode("textarea", {
              class: _normalizeClass(["basic message", { dark: $setup.darkMode }]),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.inputMessage) = $event)),
              placeholder: "コメント"
            }, null, 2), [
              [_vModelText, $setup.inputMessage]
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["submit", { disabled: !$setup.postable, dark: $setup.darkMode }]),
            onClick: $setup.postMessage
          }, "投稿する", 2)
        ], 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["title", { dark: $setup.darkMode }])
      }, "コメント一覧", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["messages", { dark: $setup.darkMode }])
      }, [
        ($setup.messages.length===0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["empty", { dark: $setup.darkMode }])
            }, "コメントはありません", 2))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.messages, (m) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["message", { dark: $setup.darkMode }])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(m.name), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(m.message), 1)
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString($setup.getTime(m.createdAt)), 1)
              ], 2))
            }), 256))
      ], 2)
    ])
  ], 2))
}